import { Navigate } from "react-router-dom";
import useRoles from "../hooks/useRoles";

import NavBar from "../components/common/NavBar/NavBar";
import { Auth } from "./Constants";

import styled from "styled-components";
import Footer from "../components/common/Footer/Footer";

const ProtectedRoute = ({
  component: Component,
  condition = true,
  loggedInInitials,
  componentProps,
  ...restOfProps
}) => {
  const { storageData } = useRoles();

  let result = <Navigate replace to={Auth.LOGIN} />;

  if (storageData?.isLoggedIn && condition)
    result = (
      <Component
        setLoggedInInitials={restOfProps?.setLoggedInInitials}
        {...componentProps}
      />
    );

  return (
    <Layout>
      <NavBar />
      {result}
      <Footer />
    </Layout>
  );
};

const Layout = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
  min-height: 100vh;
`;

export default ProtectedRoute;
